export default function Hero() {
  const handleScroll = (e: React.MouseEvent<HTMLAnchorElement>, id: string) => {
    e.preventDefault();
    const el = document.querySelector(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=dark%20cinematic%20atmosphere%20with%20warm%20golden%20ambient%20light%2C%20movie%20theater%20curtains%20in%20deep%20red%20tones%2C%20soft%20glowing%20film%20projector%20light%20beam%2C%20elegant%20dark%20background%20with%20subtle%20gold%20accents%2C%20abstract%20cinematic%20composition%2C%20luxurious%20texture%2C%20no%20text%20no%20people&width=1920&height=1080&seq=hero-bg-97cinema&orientation=landscape"
          alt="97影院-高清影视观影氛围背景"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/45 to-black/70"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-24">
        <div className="max-w-screen-2xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-3 py-1 text-xs font-medium text-accent-200 bg-accent-500/20 rounded-full border border-accent-500/30 mb-4 whitespace-nowrap">
              免费高清影视平台
            </span>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold font-heading text-background-50 leading-tight mb-4">
              97影院 · 蓝光超清画质
              <br className="hidden sm:block" />
              不缓冲流畅播放
            </h1>

            <p className="text-base md:text-lg text-background-200/80 max-w-2xl mb-6 leading-relaxed">
              97影院汇集海量高清电影与电视剧资源，覆盖科幻、悬疑、动作、动漫、韩剧等全品类内容。
              每日更新最新院线大片与热播剧集，采用全球CDN加速与智能码率自适应技术，
              无论电脑还是手机，随时随地享受蓝光超清画质的极致观影体验。无需注册，完全免费。
            </p>

            <p className="text-sm md:text-base text-background-200/80 max-w-2xl leading-relaxed">
              本周更新<b className="text-accent-300 font-semibold"> 127部 </b>影片 ·
              当前热播<b className="text-accent-300 font-semibold"> 3,856部 </b>在线 ·
              片库总量突破<b className="text-accent-300 font-semibold"> 10万+</b>
            </p>

            <div className="flex flex-col sm:flex-row gap-3 mt-8 justify-center lg:justify-start">
              <a
                href="#cards"
                onClick={(e) => handleScroll(e, '#cards')}
                className="inline-flex items-center justify-center gap-2 px-6 py-3 text-sm font-semibold text-background-50 bg-accent-500 rounded-md hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-fill text-lg"></i>
                开始观影
              </a>
              <a
                href="#ranking"
                onClick={(e) => handleScroll(e, '#ranking')}
                className="inline-flex items-center justify-center gap-2 px-6 py-3 text-sm font-medium text-background-50 border border-background-300/40 rounded-md hover:bg-background-50/10 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-fire-fill text-lg"></i>
                查看热播榜
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-lg">
            <div className="relative rounded-lg overflow-hidden aspect-[4/3]">
              <img
                src="https://readdy.ai/api/search-image?query=cinematic%20film%20strip%20and%20movie%20posters%20collage%20with%20warm%20golden%20and%20deep%20red%20tones%2C%20elegant%20vintage%20cinema%20aesthetic%2C%20film%20reels%20and%20projector%20elements%2C%20dramatic%20lighting%2C%20artistic%20composition%2C%20luxurious%20texture%2C%20no%20text%20no%20people&width=800&height=600&seq=hero-visual-97cinema&orientation=landscape"
                alt="97影院主题视觉 - 电影胶片与光影艺术"
                className="w-full h-full object-cover rounded-lg"
              />
              <div className="absolute inset-0 rounded-lg border border-background-300/20 pointer-events-none"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}